import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import { useAuth } from '../../context/AuthContext';
import { signOut } from '../../services/supabase';
import newLogo from '../../assets/wegogolf-logo-light.png';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
  contain: content;
`;

const Header = styled.header`
  // background-color: #2D882D; /* We Go Golf green */
  background-color: #333; /* We Go Golf green */
  color: white;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const LogoImage = styled.img`
  height: 40px;
  margin-right: 10px;
  
  @media (max-width: 768px) {
    height: 30px;
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
`;

const UserInfo = styled.div`
  margin-right: 1rem;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const LogoutButton = styled.button`
  background: transparent;
  border: 1px solid white;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  @media (max-width: 768px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }
`;

const Content = styled.main`
  flex: 1;
  padding: 1rem;
  
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const Footer = styled.footer`
  background-color: #333;
  color: white;
  text-align: center;
  padding: 1rem;
  font-size: 0.8rem;
`;

const MainLayout = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <LayoutContainer>
      <Header>
        <Logo>
          <LogoImage src={newLogo} alt="We Go Golf" />
          {/* We Go Golf */}
        </Logo>
        {user && (
          <UserSection>
            <UserInfo>
              {user.email}
            </UserInfo>
            <LogoutButton onClick={handleLogout}>
              Logout
            </LogoutButton>
          </UserSection>
        )}
      </Header>
      
      {user && <Navigation />}
      
      <Content>
        {children}
      </Content>
      
      {/* <Footer>
        &copy; {new Date().getFullYear()} We Go Golf. All rights reserved.
      </Footer> */}
    </LayoutContainer>
  );
};

export default MainLayout; 